// src/components/Dialog/Dialog.tsx
import React from 'react';
import { useDialog } from '../../context/DialogContext';
import { AboutPage } from '../Pages/AboutPage';
import { HelpPage } from '../Pages/HelpPage';

export const Dialog: React.FC = () => {
  const { currentDialog, hideDialog } = useDialog();

  if (!currentDialog) return null;

  const renderContent = () => {
    switch (currentDialog) {
      case 'about':
        return <AboutPage />;
      case 'help':
        return <HelpPage />;
      case 'settings':
        return <div>Settings Content</div>;
      default:
        return null;
    }
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog-container">
        <button className="dialog-close" onClick={hideDialog}>×</button>
        {renderContent()}
      </div>
    </div>
  );
};